import { api } from './client';

export async function getChildCharacters(childId) {
  return api.get(`/characters/learner/${childId}`);
}

export async function getCurriculumCharacters(childId) {
  return api.get(`/characters/curriculum/${childId}`);
}

export async function updateCharacterState(childProfileId, characterId, state) {
  return api.patch('/characters/state', {
    child_profile_id: childProfileId,
    character_id: characterId,
    state,
  });
}

export async function markCharacterAsHard(childProfileId, characterId, storyId) {
  return api.post(`/characters/${characterId}/mark-hard`, {
    child_profile_id: childProfileId,
    story_id: storyId,
  });
}
